// extracted by mini-css-extract-plugin
export default {"root":"style_root__Z9mhr","message":"style_message__+rSN3"};